module.exports = __webpack_public_path__ + "img/qianru.c47f0621.png";